var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`rserver-un-transport-3`, _vm.className || ``]},[_c('div',{staticClass:"rserver-un-transport-4 montserrat-medium-gunsmoke-18px"},[_vm._v("Réserver un transport >")])])
}
var staticRenderFns = []

export { render, staticRenderFns }